import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_roster_group.breadcrumb.roster_group_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_roster_group.breadcrumb.roster_group_label2'),
    link: '/application/team',
  },
  {
    label: t('pages.application_roster_group.breadcrumb.roster_group_label3'),
  },
];
